<template>
  <v-container>
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-alert v-if="error" :value="true" color="error">
      {{ error }}
    </v-alert>
    <v-card>
      <v-card-title class="text-center mb-0 pb-0">
        <h2 class="mx-auto">
          {{ $t('employers.add_2') }}
          <br v-if="seatLimit > 0"><span v-if="seatLimit > 0" class="text-subtitle-1"><span :class="seatCount >= seatLimit ? 'error--text' : ''">{{ seatCount }}</span>/{{ seatLimit }}</span>
        </h2>
      </v-card-title>

      <SeatLimitDialog
        v-model="seatPaywall.show"
        :info="seatPaywall.info"
        :busy="seatPaywall.busy"
        @buy="buyExtraUser(signup, $event)"
        @to-tariff="seatPaywallToTariff"
      />

      <v-card-text>
        <v-container grid-list-md>
          <v-row justify="center" align="center" wrap>
            <v-flex xs12 sm12 md4 class="justify-center">
              <v-text-field
                v-model="user_name"
                :label="$t('employers.nickname') + ' *'"
                required
                data-testid="create-employee-nickname"
              ></v-text-field>
              <v-text-field
                v-model="first_name"
                :label="$t('employers.name') + ' *'"
                required
                data-testid="create-employee-name"
              ></v-text-field>
              <v-text-field
                v-model="middle_name"
                :label="$t('employers.middle_name')"
                required
                data-testid="create-employee-middle-name"
              ></v-text-field>
              <v-text-field
                v-model="last_name"
                :label="$t('employers.last_name') + ' *'"
                required
                data-testid="create-employee-surname"
              ></v-text-field>
              <phone-field
                ref="phoneField"
                v-model="phone"
                mode="strict"
                :default-country="phoneDefaultCountry"
                :label="$t('employers.phone') + ' *'"
                data-testid="create-employee-phone"
              />
              <v-text-field
                v-model="email"
                :label="$t('employers.email') + ' *'"
                required
                data-testid="create-employee-email"
              ></v-text-field>
              <v-flex class="text-center">
                <v-btn
                  v-if="checkAdminManager()"
                  @click="signup()"
                  color="primary"
                  data-testid="create-employee-submit"
                  >{{ $t('employers.registration') }}</v-btn
                >
              </v-flex>
              <v-flex class="text-center mt-3">
                {{ $t('agents.after_save_email') }}
              </v-flex>
            </v-flex>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import moment from "moment";
import seatPaywall from "@/mixins/seatPaywall";
import SeatLimitDialog from "@/components/common/SeatLimitDialog.vue";
import PhoneField from "@/components/common/PhoneField.vue";
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
import { phoneFieldsAreValid } from "@/lib/phone/fieldValidation";

export default {
  mixins: [seatPaywall],
  components: { SeatLimitDialog, PhoneField },
  data: () => ({
    user: [],
    user_name: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    phone: null,
    email: null,
    show1: false,
    isLoading: false,
    isLoadingSubscribeToPaidTariff: false,
    error: ""
  }),
  created() {
    if (this.$store.getters.isLoggedIn) {
      if (!this.$store.getters.isSuperAdmin && !this.$store.getters.isAdmin && !this.$store.getters.isManager) {
        this.goBack();
        this.$notify(this.$t('errors.not_permitted_title'), this.$t('errors.only_admins_2'), "error");
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
    phoneDefaultCountry() {
      const company = this.$store.getters.getCompany;
      return defaultPhoneCountry({ company: company && company.company });
    },
    // FT-077: эффективный лимит мест (Plan.users_limit + extra_user). Fallback на plan.users_limit
    // для совместимости в окно деплоя (если бэкенд ещё не отдаёт effective_users_limit).
    seatLimit() {
      const mc = this.$store.getters.getMainCompany;
      if (!mc) return 0;
      if (mc.effective_users_limit != null) return mc.effective_users_limit;
      return (mc.plan && mc.plan.users_limit) || 0;
    },
    seatCount() {
      const mc = this.$store.getters.getMainCompany;
      return (mc && mc.active_users_count) || 0;
    },
    userMustChangeTariffPlan() {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan && this.$store.getters.getMainCompany.plan.id) {
          if(this.$store.getters.getMainCompany.plan.name == "Старт" || this.$store.getters.getMainCompany.plan.name == "Start") {
            if(this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            } else if (!this.$store.getters.getMainCompany.plan.trial_end && this.$store.getters.getMainCompany.created_at) {
              return moment(this.$store.getters.getMainCompany.created_at).isBefore(moment().subtract(7, "day")) ? true : false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return false
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    async signup() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (!phoneFieldsAreValid(this.$refs && this.$refs.phoneField)) return;
      if (!(this.email && this.user_name && this.first_name && this.last_name && this.phone)) {
        this.$notify(this.$t('errors.all_fields_title'), this.$t('errors.all_fields_text'), "error", 5000);
        return;
      }
      // FT-077: soft-чек убран — лимит мест энфорсит бэкенд (422 user_limit_reached),
      // пейвол открывается из .catch с серверным payload (вкл. цену доп.места).
      let self = this;
      this.isLoading = true;
      try {
        this.axios
          .post(
            "/create_employee",
            {
              users: {
                name: self.user_name,
                first_name: self.first_name,
                middle_name: self.middle_name,
                last_name: self.last_name,
                phone: self.phone,
                email: self.email,
                role: "user",
              },
            },
            { headers: { Authorization: this.$store.getters.getAuthToken } }
          )
          .then((response) => {
            // Тот же контракт, что у /create_agent (см. CreateAgent.vue):
            // SignupController#create_employee на успехе рендерит
            // `json: user, status: :created`, а при откате внутри транзакции —
            // ничего, и Rails отдаёт head :no_content. Для axios 204 — успех,
            // поэтому здесь показывался «Сотрудник добавлен» на несозданном
            // сотруднике. Битого URL, в отличие от агента, не возникало —
            // переход статический на /admin/users, — но сообщение врало.
            const createdId = response && response.data && response.data.id;
            if (!createdId) {
              this.$notify(
                this.$t('errors.employer_add'),
                this.$t('errors.something_went_wrong'),
                "error",
                6000
              );
              return;
            }
            this.$router.replace("/admin/users");
            this.$notify(this.$t('employers.added'), this.$t('employers.added_text'), "success");
          })
          .catch(error => {
            // FT-077: seat-лимит → маркетинговый пейвол (ретрай после покупки доп.места).
            if (this.maybeSeatPaywall(error)) return;
            if (error.response && error.response?.status === 422) {
              this.$notify(this.$t('employers.email_exists'), "", "error", 5000);
            } else {
              this.setError(error, this.$t('errors.employer_add'));
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      } catch (error) {
        this.isLoading = false;
        this.setError(error, this.$t('errors.error'));
        console.log(error);
      }
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    checkAdminManager() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin || this.$store.getters.isManager;
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        var fpath = this.PageData.backCrumb.url;
        this.$router
          .push({
            path: fpath
          })
          .catch(err => {});
      }
    },
    subscribeToPaidTariff() {
      this.$router.push({ name: "Transactions" });
    },
    toTariffOnSite() {
      window.open(`https://rentprog.${this.$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${this.$root.$i18n.locale}/tariffs`, '_blank');
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment())) {
              return false;
            }
            return !this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    }
  }
};
</script>
